module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bIyWF"))).then(() => parcelRequire('dJXJK'));